import React from 'react';
import ReactDOM from 'react-dom';

import DatePicker from 'components/layout/forms/DatePicker';

// The table clips everything outside it, so the calendar is rendered on top of the page
const CalendarOnTop = ({
  children,
}: {
  children: React.ReactNode[];
}): React.ReactPortal => ReactDOM.createPortal(children, document.body);

/**
 * Date filter of a material-table column, with week numbers like the other calendars of
 * the application. Use as the filterComponent of a column of type 'date'.
 */
const DateFilter = ({
  columnDef,
  onFilterChanged,
}: {
  columnDef: any;
  onFilterChanged: (columnId: string, value: Date | null) => void;
}): JSX.Element => {
  const filterValue = columnDef.tableData?.filterValue;
  // A filter restored from the saved filters is a string
  const selected = filterValue ? new Date(filterValue) : null;

  return (
    <div className="table-date-filter">
      <DatePicker
        isClearable
        popperContainer={CalendarOnTop}
        // The date columns are at the right edge of the tables
        popperPlacement="bottom-end"
        onChange={(date) =>
          onFilterChanged(
            columnDef.tableData.id,
            // Noon of the chosen day, as the server reads the date of the UTC time and
            // midnight in Finland is still the previous day in UTC
            date instanceof Date
              ? new Date(
                  date.getFullYear(),
                  date.getMonth(),
                  date.getDate(),
                  12
                )
              : null
          )
        }
        selected={
          selected !== null && !Number.isNaN(selected.getTime())
            ? selected
            : null
        }
      />
    </div>
  );
};

export default DateFilter;
